import React from 'react';
import './Hero.css';

function Hero() {
    return (
        <section className="hero">
            <div className="hero-container">
                <img src="/logo.png" alt="AI talent copilot" className="hero-logo" />
                <h1 className="hero-title">AI talent copilot</h1>
                <p className="hero-subtitle">Your AI-powered talent search and management platform</p>

                <button className="btn btn-primary btn-large">🔐 Sign in with Google</button>

                <p className="hero-caption">Sign in to access all features, sync your connections, and get personalized recommendations</p>

                <p className="hero-description">
                    Find talented people in your network, search with natural language, and get AI-powered recommendations — all in one place.
                </p>

                <div className="features-grid">
                    <div className="feature-card">
                        <div className="feature-icon">🌐</div>
                        <h3>Chrome Extension</h3>
                        <ul>
                            <li>One-click sync of connections</li>
                            <li>Smart profile scraping</li>
                            <li>Natural language search</li>
                            <li>AI-powered recommendations</li>
                        </ul>
                        <button className="btn btn-secondary">Install Extension</button>
                    </div>

                    <div className="feature-card">
                        <div className="feature-icon">⚡</div>
                        <h3>Quick Search</h3>
                        <ul>
                            <li>Search by skills and experience</li>
                            <li>Filter by location and company</li>
                            <li>Get instant insights</li>
                            <li>Privacy-first, local storage</li>
                        </ul>
                        <button className="btn btn-secondary">Try Now</button>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default Hero;
